export default "__VITE_PUBLIC_ASSET__4509403b__"